import DOMPurify from 'dompurify';

const BLOCK_TAGS = new Set(['P', 'DIV', 'UL', 'OL', 'BLOCKQUOTE', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'PRE']);
const BLOCK_HTML = /^(?:<(p|div|ul|ol|blockquote|h[1-6]|pre)\b[^>]*>[\s\S]*<\/\1>\s*)+$/i;

function isRichTextHtml(text) {
  const trimmed = text.trim();
  const startingTag = trimmed.match(/^<(p|div|ul|ol|blockquote|h[1-6]|pre)\b[^>]*>/i)?.[1];
  if (!startingTag || !new RegExp(`</${startingTag}\\s*>`, 'i').test(trimmed)) return false;
  const sanitized = DOMPurify.sanitize(trimmed);
  if (!BLOCK_HTML.test(sanitized)) return false;
  const template = document.createElement('template');
  template.innerHTML = sanitized;
  return Array.from(template.content.childNodes).every(node => (
    node.nodeType === Node.TEXT_NODE ? !node.textContent.trim() : BLOCK_TAGS.has(node.nodeName)
  ));
}

/** Accept saved rich HTML while keeping old plain-text notes literal. */
export function toRichTextHtml(content) {
  const text = typeof content === 'string' ? content : '';
  if (!text || isRichTextHtml(text)) return text;
  const escaped = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  return escaped.split(/\r\n|\r|\n/).map(line => `<p>${line}</p>`).join('');
}

/** Visible text for empty checks, search, and histories; never returns HTML markup. */
export function getRichTextPlainText(content) {
  const text = typeof content === 'string' ? content : '';
  if (!isRichTextHtml(text)) return text;
  const fragment = DOMPurify.sanitize(text, { RETURN_DOM_FRAGMENT: true });
  fragment.querySelectorAll('br').forEach(node => node.replaceWith(document.createTextNode('\n')));
  Array.from(fragment.querySelectorAll('p, div, li, blockquote, h1, h2, h3, h4, h5, h6, pre')).reverse().forEach(node => {
    if (!node.textContent.endsWith('\n')) node.appendChild(document.createTextNode('\n'));
  });
  return (fragment.textContent || '').replace(/\n{3,}/g, '\n\n').trim();
}
